import React from 'react';
import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { keyframes } from '@emotion/react';
import about1 from '../assets/about1.jpg';
import Stats from './Stats';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ForkLeft } from '@mui/icons-material';

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
`;

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255, 215, 0, 0.7); }
  70% { box-shadow: 0 0 0 15px rgba(255, 215, 0, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 215, 0, 0); }
`;

const Hero = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                background: `radial-gradient(circle at 50% 50%, #2a0808 0%, #000000 100%)`,
                position: 'relative',
                overflow: 'hidden',
                pt: { xs: 15, md: 0 } // Padding top for mobile due to fixed header
            }}
        >
            {/* Background Decorative Elements */}
            <Box sx={{
                position: 'absolute',
                top: '-10%',
                right: '-10%',
                width: '50vw',
                height: '50vw',
                background: 'radial-gradient(circle, rgba(139,0,0,0.2) 0%, rgba(0,0,0,0) 70%)',
                borderRadius: '50%',
                zIndex: 0
            }} />

            <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
                <Grid container spacing={6} alignItems="center">

                    {/* Text Content */}
                    <Grid item xs={12} md={6}>
                        <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                            <Typography
                                variant="overline"
                                sx={{
                                    color: theme.palette.secondary.main,
                                    fontSize: '1.2rem',
                                    letterSpacing: '0.2em',
                                    fontWeight: 700,
                                    display: 'block',
                                    mb: 1
                                }}
                            >
                            </Typography>

                            <Typography
                                variant="h1"
                                gutterBottom
                                sx={{
                                    fontSize: { xs: '2.5rem', md: '4rem' },
                                    textShadow: '0 0 20px rgba(139,0,0,0.8)',
                                    lineHeight: 1.1
                                }}
                            >
                                ESCOBAR <br />
                                <span style={{ color: theme.palette.secondary.main }}>ONLINE BOOK</span>
                                <Typography variant="h6" sx={{ color: theme.palette.secondary.main, fontWeight: 700, textAlign: 'center', marginLeft: { xs: 0, md: '180px' }, whiteSpace: 'nowrap' }}>
                                    (Since 2017)
                                </Typography>
                            </Typography>

                            <Box sx={{
                                display: 'inline-block',
                                border: `1px solid ${theme.palette.secondary.main}`,
                                px: 2,
                                py: 0.5,
                                mb: 3,
                                borderRadius: '4px',
                                background: 'rgba(255, 215, 0, 0.1)'
                            }}>
                                <Typography variant="subtitle1" sx={{ color: theme.palette.secondary.main, fontWeight: 700 }}>
                                    ▅▄⚜️★( OLDEST BOOK OF INDIA )★
                                </Typography>
                            </Box>

                            <Typography
                                variant="h5"
                                sx={{
                                    mb: 4,
                                    color: 'rgba(255,255,255,0.9)',
                                    maxWidth: '600px',
                                    mx: { xs: 'auto', md: 0 },
                                    lineHeight: 1.6,
                                    fontSize: '1.2rem'
                                }}
                            >
                                No Limits in Casino | Superfast Refill | 24/7 Deposit & Withdrawal
                                <br />
                                <span style={{ fontSize: '1rem', opacity: 0.8 }}>
                                    1000+ International & Indian Casino Available ♥️🎯♣️🎲♦️🎰♠️
                                </span>
                            </Typography>

                            <Button
                                variant="contained"
                                startIcon={<WhatsAppIcon />}
                                onClick={() => window.open("https://wa.me/+918169699090")}
                                sx={{
                                    fontSize: '1.2rem',
                                    px: 6,
                                    py: 1.5,
                                    borderRadius: '50px',
                                    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                    boxShadow: '0 0 20px rgba(255, 215, 0, 0.4)',
                                    animation: `${pulse} 2s infinite`,
                                    color: '#fff',
                                    fontWeight: 800
                                }}
                            >
                                Get Your ID Now
                            </Button>
                        </Box>
                    </Grid>

                    {/* Graphic/Stats Content */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                position: 'relative',
                                animation: `${float} 6s ease-in-out infinite`
                            }}
                        >
                            {/* Main Image with Glow */}
                            <Box
                                component="img"
                                src={about1}
                                alt="Casino Chips"
                                sx={{
                                    width: '100%',
                                    maxWidth: '600px',
                                    borderRadius: '30px',
                                    boxShadow: `0 20px 50px rgba(0,0,0,0.5)`,
                                    border: `1px solid ${theme.palette.secondary.main}`,
                                    display: 'block',
                                    mx: 'auto'
                                }}
                            />

                            {/* Floating Stats Card Overlay */}
                            <Box sx={{ mt: -5, position: 'relative', zIndex: 2 }}>
                                <Stats />
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </Container>
        </Box>
    );
};

export default Hero;
